import { render, staticRenderFns } from "./HomeProductTraceComponent.vue?vue&type=template&id=5950b134&scoped=true&"
import script from "./HomeProductTraceComponent.vue?vue&type=script&lang=js&"
export * from "./HomeProductTraceComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomeProductTraceComponent.vue?vue&type=style&index=0&id=5950b134&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5950b134",
  null
  
)

export default component.exports